/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';

export default class ContentBundleDeleteService extends BaseService {
  constructor() {
    super(constants.CONTENT_BUNDLE_DELETE, 'contentBundleDeleteStatus');
  }

  handleEvent(eventName, event) {
    const { bundleId, bookId } = event;
    if (bookId && bundleId) {
      return this.getClient('evergreen').post('/contentbundle/delete', { bookId, bundleId });
    }
    return null;
  }

  handleResponse(response, event) {
    // eslint-disable-line class-methods-use-this
    const { status } = response || {};
    if (status === 200 || status === 204) {
      const store = Framework.getStoreRegistry().getStore('contentBundleState');
      store.setDeleteStatus('success');
      store.fetchBundles(event.bookId);
      const notification = {
        open: true,
        message: 'Content Bundle deleted successfully!',
        type: 'info'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    Framework.getStoreRegistry().getStore('contentBundleState').setDeleteStatus('error');
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if ((status === 500 || status === 400) && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message ? data.error.message : data.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    }
  }
}
